import type { CpuThresholds } from '../duel/cpu'
import type { PlayerPublic } from '../protocol'

/** The house player of Connect Four. A real `players` row exists for it on the server. */
export const C4_BOT_ID = 'cpu:drop-9000'

export const C4_BOT: PlayerPublic = {
  id: C4_BOT_ID,
  nickname: 'DROP-9000',
  avatar: '🤖',
  color: 'amber',
}

/** Connect Four games run longer than XOX ones, so "quick" and "long" mean more plies. */
export const C4_CPU_THRESHOLDS: CpuThresholds = { quickPlies: 12, longPlies: 28 }
